<template>
  <Card shadow>
    <p slot="title">
      歷史月份最高在線人數
      <span class="card-small-title">(近六月单位)</span>
    </p>
    <div slot="extra">
      <DatePicker
        :value="startDate"
        confirm
        type="month"
        class="home-Date-input"
        placeholder="开始月份"
        @on-change="event => startDate = event"
        @on-ok="linkonlinemem"
        :clearable="false"
        placement="bottom-end"
        style="width: 100px"
      ></DatePicker>-
      <DatePicker
        :value="endDate"
        confirm
        type="month"
        class="home-Date-input"
        placeholder="开始月份"
        @on-change="event => endDate = event"
        @on-ok="linkonlinemem"
        :clearable="false"
        placement="bottom-end"
        style="width: 100px"
      ></DatePicker>
    </div>
    <v-chart :options="polar" autoresize style="height:300px;padding-top: 2px" />
  </Card>
</template>
<script>
import moment from "moment-timezone";
import echartsmixins from '../mixins/echarts'
export default {
  name: 'ChartsMonthNumber',
  mixins: [echartsmixins],
  data () {
    return {
      data: [],
      items: [],
      startDate: '',
      endDate: '',
      ApiDate: [],
      polar: {
        title: {
          //   text: '各站点每月最高上线人数',
          //   subtext: '每月份单位',
          //   padding: 10
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter(item) {
            const data = item.data
            return `
              <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background:${item.color}"></span>
              <strong>${data.name} ${data.time}</strong><br/>
              最高在線人數：${data.value}<br/>
              總會員數：${data.memcou}<br/>
              總代理數：${data.amcou}<br/>
              總操作员數：${data.adcou}<br/>
            `
          }
        },
        toolbox: {
          right: 10,
          feature: {
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: function (opt) {
                let axisData = opt.xAxis[0].data; //坐标数据
                let series = opt.series; //折线图数据
                let tdHeads = '<td  style="padding: 0 10px">时间</td>'; //表头
                let tdBodys = ''; //数据
                series.forEach(function (item) {
                  //组装表头
                  tdHeads += `<td style="padding: 0 10px">${item.name}</td>`;
                });
                let table = `<table border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
                for (let i = 0, l = axisData.length; i < l; i++) {
                  for (let j = 0; j < series.length; j++) {
                    //组装表数据
                    let value = typeof series[j].data[i] === 'object'
                      ? series[j].data[i].value
                      : series[j].data[i]

                    tdBodys += `<td>${value}</td>`;
                  }
                  table += `<tr><td style="padding: 0 10px">${axisData[i]}</td>${tdBodys}</tr>`;
                  tdBodys = '';
                }
                table += '</tbody></table>';
                return table;
              }
            },
            magicType: { show: true, type: ['line', 'bar'] },
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: []
        },
        xAxis: {
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          data: [],
          name: '月份',
        },
        yAxis: [
          {
            name: '人数',
            type: 'value',
            position: 'left',
            boundaryGap: [0, '100%'],
            axisLine: {
              lineStyle: {
                color: '#1d3c78'
              }
            }
          }
        ],
        series: [],
        animationDuration: 2000
      },
    }
  },
  mounted () {
    this.$Eventhub.$on('setChartsMonth', (val) => {
      this.data = val
      this.fristData()
    })
  },
  beforeDestroy () {
    this.$Eventhub.$off('setChartsMonth')
  },
  methods: {
    fristData () {
      this.endDate =  moment().format("YYYY-MM")
      this.startDate =  moment(this.endDate).subtract(5, 'month').format("YYYY-MM")
      this.linkonlinemem()
    },
    refresh () {
      this.polar.xAxis.data = []
      this.polar.series = []
      this.polar.legend.data = []
    },
    async linkonlinemem () {
      this.refresh()
      try {
        let start_date = moment(this.startDate);
        let end_date = moment(this.endDate);
        let months = end_date.diff(start_date, "months");
        this.items = this.data.map((it, index) => {
          if (!it.data.hispeak) return
          let data = []
          const dataState = Array.isArray(it.data) && !it.data.length
          for (let i = 0; i <= months; i++) {
            if(dataState) {
              data.push(0)
            } else {
              let text = moment(start_date, "YYYY-MM").add(i, 'months');
              let tiem = text.format("YYYY-MM")
              if (index == 0) this.polar.xAxis.data.push(tiem)
              const indexOf = it.data.hispeak.map(it => it.monthline).indexOf(tiem)
              if (indexOf != '-1') {
                data.push({
                  value: it.data.hispeak[indexOf].maxonlinememcou,
                  memcou: it.data.hispeak[indexOf].memcou,
                  amcou: it.data.hispeak[indexOf].amcou,
                  adcou: it.data.hispeak[indexOf].adcou,
                  time: it.data.hispeak[indexOf].monthline,
                  name: it.memname
                })
              } else {
                data.push({
                  value: 0,
                  memcou: 0,
                  amcou: 0,
                  adcou: 0,
                  time: ''
                })
              }
            }
            
          }
          const series = this.seriesObject(it, index, data)
          this.polar.series.push(series)
          this.polar.legend.data.push(it.memname)
          return it
        })
      } catch (error) {
        console.log(error);
      }
    },
    seriesObject (val, index, data) {
      const max = data.reduce((acc, val, i) => {
        if(val != 0) acc.push({
          value: val.value,
          xAxis: i,
          yAxis: val.value,
          name: val.name || val.seriesName || '',
          time: val.time || '',
          memcou: val.memcou,
          amcou: val.amcou,
          adcou: val.adcou
        })
        return acc
      }, [])
      return {
        name: val.memname,
        type: 'bar',
        data: data,
        itemStyle: { color: this.colors[index] },
        markPoint: {
          data: max
        }
      }
    }
  }
}
</script>